import * as api from '../api/massCassValidation';
import { createRequestTypes, prefix, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';

export const SET_MASS_CASS_VALIDATION_CREATE_NEW_DIALOGUE_IS_VISIBLE = `${prefix}/SET_MASS_CASS_VALIDATION_CREATE_NEW_DIALOGUE_IS_VISIBLE`;

export const CREATE_MASS_CASS_VALIDATION_JOB = createRequestTypes(
  `${prefix}/CREATE_MASS_CASS_VALIDATION_JOB`,
);

export const createJob = makeApiActionCreatorV3(
  api.createJob,
  CREATE_MASS_CASS_VALIDATION_JOB[START],
  CREATE_MASS_CASS_VALIDATION_JOB[SUCCESS],
  CREATE_MASS_CASS_VALIDATION_JOB[ERROR],
);

export const CONVERT_MASS_CASS_VALIDATION_ADDRESSES = createRequestTypes(
  `${prefix}/CONVERT_MASS_CASS_VALIDATION_ADDRESSES`,
);

export const convertAddresses = makeApiActionCreatorV3(
  api.convertAddresses,
  CONVERT_MASS_CASS_VALIDATION_ADDRESSES[START],
  CONVERT_MASS_CASS_VALIDATION_ADDRESSES[SUCCESS],
  CONVERT_MASS_CASS_VALIDATION_ADDRESSES[ERROR],
);

export const VALIDATE_MASS_CASS_VALIDATION_QUERY = createRequestTypes(
  `${prefix}/VALIDATE_MASS_CASS_VALIDATION_QUERY`,
);

export const validateQuery = makeApiActionCreatorV3(
  api.validateQuery,
  VALIDATE_MASS_CASS_VALIDATION_QUERY[START],
  VALIDATE_MASS_CASS_VALIDATION_QUERY[SUCCESS],
  VALIDATE_MASS_CASS_VALIDATION_QUERY[ERROR],
);

export const FETCH_MASS_CASS_VALIDATION_JOBS = createRequestTypes(
  `${prefix}/FETCH_MASS_CASS_VALIDATION_JOBS`,
);

export const fetchJobs = makeApiActionCreatorV3(
  api.fetchJobs,
  FETCH_MASS_CASS_VALIDATION_JOBS[START],
  FETCH_MASS_CASS_VALIDATION_JOBS[SUCCESS],
  FETCH_MASS_CASS_VALIDATION_JOBS[ERROR],
);

export const FETCH_MASS_CASS_VALIDATION_JOB_DETAILS = createRequestTypes(
  `${prefix}/FETCH_MASS_CASS_VALIDATION_JOBS_DETAILS`,
);

export const fetchJobDetails = makeApiActionCreatorV3(
  api.fetchJobDetails,
  FETCH_MASS_CASS_VALIDATION_JOB_DETAILS[START],
  FETCH_MASS_CASS_VALIDATION_JOB_DETAILS[SUCCESS],
  FETCH_MASS_CASS_VALIDATION_JOB_DETAILS[ERROR],
);

export const ADD_MASS_CASS_VALIDATION_JOB = `${prefix}/ADD_MASS_CASS_VALIDATION_JOB`;

export const addJob = (newJob) => ({
  type: ADD_MASS_CASS_VALIDATION_JOB,
  payload: newJob,
});

export const UPDATE_MASS_CASS_VALIDATION_JOB = `${prefix}/UPDATE_MASS_CASS_VALIDATION_JOB`;

export const updateJob = (updatedJob) => ({
  type: UPDATE_MASS_CASS_VALIDATION_JOB,
  payload: updatedJob,
});

export const SET_MASS_CASS_VALIDATION_JOBS_TABLE_PAGE_SIZE = `${prefix}/SET_MASS_CASS_VALIDATION_JOBS_TABLE_PAGE_SIZE`;

export const setJobsTablePageSize = (pageSize) => ({
  type: SET_MASS_CASS_VALIDATION_JOBS_TABLE_PAGE_SIZE,
  payload: pageSize,
});
